export default __webpack_public_path__ + "static/media/slick-carousel-preloader-primary.4d18334b.svg";